import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: '{{orderMethod}} stimata: {{day}} intorno alle {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Ordine rifiutato',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Ordine ricevuto',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Il tuo ordine è stato visto',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Ordine confermato',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Ordine pronto',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Ordine in consegna',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Ordine completato',
    },
  },
  labels: {
    today: 'Oggi',
  },
  waiting_confirmation: {
    title: 'In attesa di conferma ordine',
    description: 'Attendi...',
  },
  pickup_time: {
    title: 'Orario di ritiro',
    description: 'Confermato da {{name}}',
  },
  delivery_time: {
    title: 'Orario di consegna',
    description: 'Confermato da {{name}}',
  },
  warning_label: {
    pickup_time_changed: "{{company}} ha modificato l'orario da {{initialTime}} a {{currentTime}}",
  },
};
